"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _ThemeProvider = require("../../../theme/ThemeProvider");

var _Label = _interopRequireDefault(require("../../Label"));

var _classnames = _interopRequireDefault(require("classnames"));

var useStyles = (0, _ThemeProvider.createUseStyles)({
  Label: {
    fontSize: 13,
    fontWeight: 500
  }
});

/**
 * Indicator Entry component which wraps around a Label
 */
var IndicatorEntry = function IndicatorEntry(_ref) {
  var active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["active", "children", "className"]);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(_Label["default"], (0, _extends2["default"])({
    className: (0, _classnames["default"])(classes.Label, className)
  }, rest), children);
};

exports["default"] = IndicatorEntry;
//# sourceMappingURL=Entry.js.map